import { createFileRoute, notFound } from "@tanstack/react-router";

import { SensoryProfileForm } from "@/components/sensory-profile/sensory-profile-form";
import { isSensoryProfileStepId } from "@/lib/routes";

export const Route = createFileRoute("/sensory-profile/$stepId")({
  params: {
    parse: (raw) => {
      if (!isSensoryProfileStepId(raw.stepId)) {
        throw notFound();
      }
      return { stepId: raw.stepId };
    },
  },
  component: SensoryProfileStepPage,
});

function SensoryProfileStepPage() {
  return <SensoryProfileForm />;
}
